export default __webpack_public_path__ + "static/media/TaipeiSansTCBeta-Regular.3c32e328.ttf";